import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconsUtilityReturn = props => {
  if (props.id !== "_svgiconsutilityreturn") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path d="M2.614 13.494l3.682 5.062a.5.5 0 00.904-.294V16a1 1 0 011-1h11.4a2 2 0 002-2V6.2a2 2 0 00-2-2h-5.2a1.8 1.8 0 000 3.6H17a1 1 0 011 1v1.6a1 1 0 01-1 1H8.2a1 1 0 01-1-1V8.138a.5.5 0 00-.904-.295l-3.682 5.063a.5.5 0 000 .588z" fill="#202020" /></svg>;
};

SvgIconsUtilityReturn.displayName = "_svgiconsutilityreturn";
SvgIconsUtilityReturn.propTypes = {
  id: PropTypes.string
};
SvgIconsUtilityReturn.defaultProps = {
  id: ''
};
export default SvgIconsUtilityReturn;